import AnnotationCollection from './AnnotationCollection';

export {
    AnnotationCollection
};



// WEBPACK FOOTER //
// ./~/@girder/large_image_annotation/collections/index.js